import CloseIcon from '@mui/icons-material/Close'
import Backdrop from '@mui/material/Backdrop'

import React, { useEffect } from 'react'

import { CloseButton, BoxModal, GridModal, FadeModal } from './EditOfficeStyles'
import { useEditOffice } from './useEditOffice'
import {
  GridWrapper,
  InputAdornmentWrapper,
  ModalWrapper,
} from '../../../../../../../components'
import FormTextInput from '../../../../../../../components/FormInputText'
import { GridItem } from '../../../../../../../components/GridItem/GridItem'
import { TypographyModal } from '../../../../../../../components/ModalComponent'
import { InputCurrencyStyled } from '../../../../../../../components/StyledComponents/InputCurrencyStyled'
import { LabelInput } from '../../../../../../../components/StyledComponents/LabelInput'
import { LabelInputError } from '../../../../../../../components/StyledComponents/LabelInputError'
import SubmitButton from '../../../../../../../components/SubmitButton'
import { ParamsCheckModifyOfficeImpact } from '../../../../../../../infrastructure/dtos/CheckScheduleImpact'
import {
  IMedicalOffice, IUpdateInfoOfficeParams,
} from '../../../../../../../infrastructure/dtos/Offices'
import { validateInput } from '../../../../../../../utils/validateInput'
import AutocompleteGoogleMaps from '../../../../../../medical/ProfileMedical/RegisterConsultory/components/MapComponents/AutocompleteGoogle'
import { MapsGoogle } from '../../../../../../medical/ProfileMedical/RegisterConsultory/components/MapComponents/MapsGoogle'
import { ConfirmSchedule } from '../../../UpdateSchedule/components/ConfirmSchedule/ConfirmSchedule'

interface IEditOfficeProps {
  handleClose: () => void
  fetchUpdateOffice: (params: IUpdateInfoOfficeParams) => Promise<void>
  open: boolean
  office: IMedicalOffice
  handleModalImpactClose: (state: boolean) => void
  openModalImpact: boolean
  checkModifyOfficeImpact: (params: ParamsCheckModifyOfficeImpact) => Promise<void>
  confirm: boolean
}

export const EditOffice = ({
  handleClose,
  fetchUpdateOffice,
  open,
  office,
  openModalImpact,
  handleModalImpactClose,
  checkModifyOfficeImpact,
  confirm
}: IEditOfficeProps): JSX.Element => {
  const {
    disabledButton,
    address,
    isLoaded,
    selected,
    value,
    map,
    markerPosition,
    zoom,
    mapCenter,
    consultingRoom,
    consultingFloor,
    consultingOffice,
    appointmentPrice,
    MAX_LENGTH,
    setMarkerPosition,
    setZoom,
    setAddress,
    setMapCenter,
    setSelected,
    setValue,
    setMap,
    setConsultingRoom,
    setConsultingFloor,
    setConsultingOffice,
    handleSetAppointmentPrice,
    handleClickAutocomplete,
  } = useEditOffice(office)

  const handleFetch = (): void => {
    fetchUpdateOffice({
      building_floor: consultingFloor,
      building_name: consultingRoom,
      consultation_value: Number(appointmentPrice),
      coordinates_medical_office: {
        latitude: markerPosition?.lat() as number,
        longitude: markerPosition?.lng() as number,
      },
      name_medical_office: address,
      office_id: office?.office_id,
      office_number: consultingOffice,
      user_id: office?.user_id,
    }).then()
  }

  useEffect(() => {
    if(confirm){
      handleFetch()
    }

  }, [confirm])

  return (
  <>
    <ModalWrapper
      aria-labelledby="modal-edit-office-title"
      aria-describedby="modal-edit-office-description"
      open={open}
      role="dialog"
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <FadeModal in={open}>
        <BoxModal width={{ xs: '90%', md: '60%' }}>
          <GridModal>
            <TypographyModal id="modal-edit-office-title" variant="h6">
              Modifica tu dirección
            </TypographyModal>
            <CloseButton onClick={handleClose}>
              <CloseIcon />
            </CloseButton>
            <GridWrapper
              container
              mt={3}
              display={'flex'}
              justifyContent={'center'}
              flexDirection={{ xs: 'column-reverse', md: 'row' }}
            >
              <GridItem xs={12} md={6} padding={'10px'}>
                <GridWrapper container rowGap={3}>
                  <GridItem
                    xs={12}
                    flexDirection={'column'}
                    alignItems={'start'}
                  >
                    <LabelInput sx={{ marginLeft: '10px' }}>
                      ¿Dónde atiendes a tus pacientes?
                    </LabelInput>
                    {isLoaded &&
                      <AutocompleteGoogleMaps
                        address={address}
                        setMarkerPosition={setMarkerPosition}
                        setZoom={setZoom}
                        setAddress={setAddress}
                        setMapCenter={setMapCenter}
                        isLoaded={isLoaded}
                        setSelected={setSelected}
                        selected={selected}
                        value={value}
                        setValue={setValue}
                        onClick={handleClickAutocomplete}
                      />
                    }
                    {address?.length === 0 && (
                      <LabelInputError
                        sx={{ marginLeft: '10px' }}
                        id="address-helper-text"
                      >
                        Campo requerido.
                      </LabelInputError>
                    )
                    }
                  </GridItem>
                  <GridItem xs={12}>
                    <FormTextInput
                      id="consultingRoom"
                      type="text"
                      placeholder="Edificio"
                      fullWidth
                      label="Edificio"
                      name="consultingRoom"
                      value={consultingRoom}
                      onChange={(event) =>
                        setConsultingRoom(event.target.value)
                      }
                      error={
                        (!validateInput(consultingRoom) &&
                          consultingRoom.length === 0) ||
                        consultingRoom.length > MAX_LENGTH
                      }
                      helperText={
                        !validateInput(consultingRoom) &&
                        consultingRoom.length === 0
                          ? 'Campo requerido.'
                          : consultingRoom.length > MAX_LENGTH
                            ? `Máximo número de caracteres ${MAX_LENGTH}`
                            : ''
                      }
                      inputProps={{ maxLength: MAX_LENGTH + 1 }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={6} pr={0.1}>
                    <FormTextInput
                      id="consultingFloor"
                      type="text"
                      placeholder="Piso"
                      label="Piso"
                      fullWidth
                      name="consultingFloor"
                      value={consultingFloor}
                      onChange={(event) =>
                        setConsultingFloor(event.target.value)
                      }
                      error={
                        (!validateInput(consultingFloor) &&
                          consultingFloor.length === 0) ||
                        consultingFloor.length > MAX_LENGTH
                      }
                      helperText={
                        !validateInput(consultingFloor) &&
                        consultingFloor.length === 0
                          ? 'Campo requerido.'
                          : consultingFloor.length > MAX_LENGTH
                            ? `Máximo número de caracteres ${MAX_LENGTH}`
                            : ''
                      }
                      inputProps={{ maxLength: MAX_LENGTH + 1 }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={6} pl={0.5}>
                    <FormTextInput
                      id="consultingOffice"
                      type="text"
                      placeholder="Consultorio"
                      fullWidth
                      label="Consultorio"
                      name="consultingOffice"
                      value={consultingOffice}
                      onChange={(event) =>
                        setConsultingOffice(event.target.value)
                      }
                      error={
                        (!validateInput(consultingOffice) &&
                          consultingOffice.length === 0) ||
                        consultingOffice.length > MAX_LENGTH
                      }
                      helperText={
                        !validateInput(consultingOffice) &&
                        consultingOffice.length === 0
                          ? 'Campo requerido.'
                          : consultingOffice.length > MAX_LENGTH
                            ? `Máximo número de caracteres ${MAX_LENGTH}`
                            : ''
                      }
                      inputProps={{ maxLength: MAX_LENGTH + 1 }}
                    />
                  </GridItem>
                  <GridItem
                    xs={12}
                    flexDirection={'column'}
                    alignItems={'start'}
                  >
                    <LabelInput sx={{ marginLeft: '10px' }}>
                      ¿Cuánto cuesta tu consulta?
                    </LabelInput>
                    <InputCurrencyStyled
                      placeholder="Ingresa el monto"
                      id="appointment_price"
                      name="appointment_price"
                      type="number"
                      fullWidth
                      value={appointmentPrice}
                      onChange={(event) =>
                        handleSetAppointmentPrice(event.target.value)
                      }
                      startAdornment={
                        <InputAdornmentWrapper position="start">
                          $
                        </InputAdornmentWrapper>
                      }
                      error={
                        appointmentPrice.length === 0 ||
                        appointmentPrice.length > MAX_LENGTH
                      }
                      inputProps={{ maxLength: MAX_LENGTH + 1 }}
                    />
                    {appointmentPrice.length === 0 ? (
                      <LabelInputError
                        sx={{ marginLeft: '10px' }}
                        id="appointment_price-helper-text"
                      >
                        Campo requerido.
                      </LabelInputError>
                    ) : appointmentPrice.length > MAX_LENGTH ? (
                      <LabelInputError
                        sx={{ marginLeft: '10px' }}
                        id="appointment_price-helper-text"
                      >
                        {`Máximo número de caracteres ${MAX_LENGTH}`}
                      </LabelInputError>
                    ) : null}
                  </GridItem>
                </GridWrapper>
              </GridItem>
              <GridItem xs={12} md={6}>
                <MapsGoogle
                  map={map}
                  markerPosition={markerPosition}
                  zoom={zoom}
                  address={address}
                  mapCenter={mapCenter}
                  setMap={setMap}
                  setMarkerPosition={setMarkerPosition}
                  setZoom={setZoom}
                  setAddress={setAddress}
                  setMapCenter={setMapCenter}
                  isLoaded={isLoaded}
                  setSelected={setSelected}
                />
              </GridItem>
            </GridWrapper>
            <GridWrapper container mt={3}>
              <GridItem xs={12} data-testid="grid-send-update-office">
                <SubmitButton
                  data-testid={'send-update-office'}
                  id={'send-update-office'}
                  variant={'contained'}
                  fullWidth={false}
                  type={'button'}
                  text={'Actualizar'}
                  sx={{ width: '180px' }}
                  disabled={disabledButton || confirm}
                  onClick={() => {
                    checkModifyOfficeImpact({
                      user_id: office?.user_id,
                      office_id: office?.office_id,
                    })
                  }}
                />
              </GridItem>
            </GridWrapper>
          </GridModal>
        </BoxModal>
      </FadeModal>
    </ModalWrapper>
    <ConfirmSchedule
      handleClose={() => handleModalImpactClose(false)}
      open={openModalImpact}
      handleConfirm={() => {
        handleFetch()
      }}
      confirm={false}
      title={'¿Estás seguro que deseas modificar los datos del consultorio?'}
      subtitle={
        'Desde este momento los pacientes podrán visualizar los cambios en este consultorio. ' +
         'Recuerda tomar contacto con tus pacientes para notificar los cambios realizados.'
      }
    />
  </>
  )
}
